import React from 'react';
import Header from "../partials/Header";
import { Link } from "react-router-dom";
import SearchForm from '../home/SearchForm';

export default function Roma() {
    return (
        <div className="ef-page ef-city-page">
            <Header />

            <section className="ef-roma-hero" aria-labelledby="roma-hero-title">
                <div className="ef-roma-hero__inner">
                    <nav className="ef-roma-breadcrumb" aria-label="Percorso di navigazione">
                        <Link to="/">Easy Funeral</Link><span aria-hidden="true">›</span><span aria-current="page">Roma</span>
                    </nav>
                    <h1 id="roma-hero-title">
                        <span>Onoranze funebri e servizi funerari</span>
                        <span>a Roma:</span>
                        <em>una guida chiara e trasparente</em>
                    </h1>
                    <p className="ef-roma-hero__description">
                        Roma conta 11 cimiteri comunali, decine di agenzie funebri e un iter burocratico che può sembrare complesso in un momento già difficile. Easy Funeral raccoglie e verifica le agenzie della città per aiutarti a trovare — senza fretta e senza pressioni — il servizio più adatto alla tua situazione, nel quartiere giusto.
                    </p>
                    <p className="ef-roma-hero__note">Nessuna registrazione richiesta. Cerca per indirizzo e contatta le agenzie vicine.</p>
                    <ul className="ef-roma-hero__benefits">
                        <li><span aria-hidden="true">○</span> Nessuna registrazione richiesta</li>
                        <li><span aria-hidden="true">□</span> Sedi e recapiti a portata di mano</li>
                        <li><span aria-hidden="true">◇</span> Guida neutrale, scelta libera</li>
                        <li><span aria-hidden="true">◈</span> Agenzie verificate a Roma</li>
                    </ul>
                </div>
            </section>

            {/* Features */}
            <section className="mx-auto max-w-5xl px-6 py-24">
                <div className="grid gap-6 md:grid-cols-2">
                    {[
                        {
                            title: "Agenzie selezionate",
                            text: "Collaboriamo con onoranze funebri affidabili e professionali presenti su tutto il territorio romano.",
                        },
                        {
                            title: "Preventivi trasparenti",
                            text: "Contatta direttamente le agenzie per conoscere i servizi inclusi e richiedere un preventivo personalizzato.",
                        },
                        {
                            title: "Disponibilità 24/7",
                            text: "Il servizio è attivo in qualsiasi momento, anche nei casi più urgenti.",
                        },
                        {
                            title: "Copertura completa",
                            text: "Servizio attivo in tutti i quartieri di Roma, nella provincia e nel resto d'Italia.",
                        },
                    ].map((item) => (
                        <div
                            key={item.title}
                            className="border-radius border border-zinc-200 p-8"
                        >
                            <h3 className="text-lg font-semibold text-zinc-900">
                                {item.title}
                            </h3>

                            <p className="mt-3 leading-7 text-zinc-600">{item.text}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* How it works */}
            <section id="come-funziona" className="bg-secondary">
                <div className="mx-auto max-w-5xl px-6 py-24">
                    <div className="max-w-2xl">
                        <h2 className="text-3xl font-semibold tracking-tight text-zinc-900">
                            Come funziona
                        </h2>

                        <p className="mt-4 leading-7 text-zinc-600">
                            Un processo semplice e veloce per aiutarti a trovare il servizio
                            più adatto alle tue esigenze.
                        </p>
                    </div>

                    <div className="mt-16 grid gap-8 md:grid-cols-3">
                        {[
                            {
                                step: "01",
                                title: "Indica l'indirizzo",
                                text: "Seleziona l'indirizzo dai suggerimenti nel modulo a fondo pagina.",
                            },
                            {
                                step: "02",
                                title: "Visualizza le proposte",
                                text: "Ti proponiamo agenzie qualificate e disponibili nelle tue vicinanze.",
                            },
                            {
                                step: "03",
                                title: "Scegli con serenità",
                                text: "Consulta le schede e contatta senza impegno le agenzie per concordare i servizi e richiedere un preventivo.",
                            },
                        ].map((item) => (
                            <div key={item.step}>
                                <span className="text-sm font-medium text-zinc-400">
                                  {item.step}
                                </span>

                                <h3 className="mt-3 text-xl font-semibold text-zinc-900">
                                    {item.title}
                                </h3>

                                <p className="mt-3 leading-7 text-zinc-600">{item.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Areas */}
            <section className="mx-auto max-w-5xl px-6 py-24">
                <div className="grid gap-16 md:grid-cols-2">
                    <div>
                        <h2 className="text-3xl font-semibold tracking-tight text-zinc-900">
                            Servizio disponibile in tutta Roma
                        </h2>

                        <p className="mt-6 leading-7 text-zinc-600">
                            Ti aiutiamo a trovare onoranze funebri nei principali quartieri di
                            Roma, nei comuni limitrofi e tutto il resto d'Italia.
                        </p>
                    </div>

                    <div className="grid grid-cols-2 gap-4 text-zinc-700">
                        {[
                            "Roma Centro",
                            "Prati",
                            "EUR",
                            "San Giovanni",
                            "Parioli",
                            "Monteverde",
                            "Tiburtina",
                            "Cinecittà",
                            "Montesacro",
                            "Ostia",
                        ].map((area) => (
                            <div
                                key={area}
                                className="border-radius border border-zinc-200 px-4 py-3"
                            >
                                {area}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section id="trova-onoranze-funebri-roma" className="border-t border-zinc-200 bg-secondary">
                <div className="mx-auto max-w-4xl px-6 py-24 text-center">
                    <h2 className="text-3xl font-semibold tracking-tight text-zinc-900">
                        Trova l'onoranza giusta
                    </h2>

                    <p className="mx-auto mt-6 max-w-2xl leading-7 text-zinc-600">
                        Indica l'indirizzo per trovare rapidamente un’agenzia funebre
                        professionale a Roma. Servizio semplice, rapido e senza impegno.
                    </p>

                    <div className="mt-12"><SearchForm /></div>
                </div>
            </section>

            <section className="ef-roma-facts" aria-labelledby="roma-facts-title">
                <div>
                    <h2 id="roma-facts-title">Utile sapere · Roma</h2>
                    <div className="ef-roma-facts__grid">
                        <article>
                            <h3>I cimiteri comunali di Roma</h3>
                            <p>Roma gestisce 11 cimiteri comunali attraverso AMA. Il Verano e Prima Porta sono i più grandi, ma sono presenti anche strutture di prossimità in altre zone della città.</p>
                        </article>
                        <article>
                            <h3>Tempi medi per le pratiche</h3>
                            <p>I tempi variano in base alla pratica e alla completezza dei documenti. Chiedi all'agenzia una stima aggiornata e quali autorizzazioni servono nel tuo caso.</p>
                        </article>
                        <article>
                            <h3>Servizi di trasporto in città</h3>
                            <p>Il traffico e la viabilità romana rendono fondamentale affidarsi ad agenzie con mezzi e personale abituati alla città. Verifica sempre copertura notturna e festiva.</p>
                        </article>
                    </div>
                </div>
            </section>
        </div>
    );
}
